window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.casinoSuperkisaAktivnaRepo = function () {
    var url = 'api/casinosuperkisaaktivna';

    var get = function () {
        return fetch(url, { credentials: repos.base.credentials })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(function (error) {
                // Nekriticna provjera (samo optimizacija pollanja) - NE smije pokrenuti fatalni
                // "Greska u komunikaciji" screen. Na bilo kakvu gresku vracamo undefined, a
                // klijent se u tom slucaju vraca na klasicni 5-sekundni polling.
                console.warn('casinoSuperkisaAktivnaRepo error:', error);
                return undefined;
            });
    };

    return {
        get: get
    }
}();
